export { default } from './svg/align-center.svg';
